import { Component, OnInit } from '@angular/core';
import { ResourcesService } from '../services/resources.service';
import { LogService } from '../services/log.service';

@Component({
  selector: 'app-desktop-announcement',
  templateUrl: './desktop-announcement.component.html',
  styleUrls: ['./desktop-announcement.component.css']
})
export class DesktopAnnouncementComponent implements OnInit {

  constructor(public resourcesService: ResourcesService, public log: LogService) { }

  public announcementArray = [];
  public emptyAnnouncement = false;
  public message = "";
  public response;
  public spinner = true


  ngOnInit() {
    this.resourcesService.announcementObj.subscribe(response => {
      this.response = response;
      this.log
        .addLog({
        action: "Access",
        component: "Resources Announcement",
        details: `Accessed & Fetched Resources Announcement in resource - ${this.response.resource_det.resource} - ${this.response.resource_det.topic} - ${this.response.resource_det.title}`,
      }).subscribe(data => { });
      this.getAnnouncements();
    })
  }

  getAnnouncements() {
    this.resourcesService.getAnnouncements(this.response).subscribe(data => {
      this.announcementArray = data;
      if (this.announcementArray.length <= 0) {
        this.emptyAnnouncement = true;
        this.message = "No Announcement in this course."
      } else {
        this.emptyAnnouncement = false;
        this.message = "";
      }
      this.spinner = false;
    })
  }

}
